import { defineStore } from "pinia"
import { ref } from "vue"

export const useExitIframeModalStore = defineStore("exitIframeModal", () => {
  const iframeToken = ref<string | null>(null)
  const sharepoolUuid = ref<string | null>(null)
  const targetUuid = ref<string | null>(null)
  const goToParam = ref<string | null>(null)

  // Passé à true quand une requête répond 401 alors qu'on est dans une iframe :
  // les cookies tiers y sont bloqués, la page de login ne peut pas s'y afficher,
  // la seule sortie est le bouton "ouvrir dans un nouvel onglet" de la modale.
  const isBlocked = ref(false)

  return {
    iframeToken,
    targetUuid,
    sharepoolUuid,
    goToParam,
    isBlocked,
  }
})
